import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { QuantityCounterComponent } from './quantity-counter.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [QuantityCounterComponent],
  exports: [QuantityCounterComponent],
})
export class QuantityCounterModule {}
